export default "__VITE_ASSET__BDK92atp__"